import { Allotment } from "allotment";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { ReactNode, useContext, useEffect, useState } from "react";

import DatastoresMenu from "components/Organisms/DatastoresMenu/DatastoresMenu";
import DatasetsMenu from "components/Organisms/DatasetsMenu";

import { useDatastoreTypes } from "hooks/datastores/useDatastoreTypes";
import { DatastoreContext } from "contexts/datastores/datastores";

import { StyledClose, StyledPanels } from "./styles";
import { useRoutePath } from "hooks/useRoutePath";
import { useAuth } from "hooks/user/useAuth/useAuth";

interface LayoutContentProps {
  className?: string;
  children: ReactNode;
}

const LayoutContent = ({ children, className = "" }: LayoutContentProps) => {
  const { isLogged } = useAuth();

  const [activeTabType] = useRoutePath();
  const [isMount, setIsMount] = useState(false);
  const [leftSizes, setLeftSizes] = useState([60, 0]);
  const [datastoresSize, setDatastoresSize] = useState<(number | undefined)[]>([
    60, 60,
  ]);

  useEffect(() => setIsMount(true), []);
  const datastore_types = useDatastoreTypes();

  const { instance, setInstance } = useContext(DatastoreContext);
  if (!setInstance || !isMount) return null;

  const toggleDatasetsMenu = () => {
    setInstance({ ...instance, visible: !instance?.visible });
  };

  const datasetMenuMinSize = !!instance?.visible ? 200 : 0;
  const datasetMenuMaxSize = !!instance?.visible ? 1000 : 0;

  return (
    <div className={className}>
      <div className="absolute w-full h-full flex">
        <StyledPanels>
          <Allotment className="allotment-container">
            <Allotment.Pane
              minSize={60 + leftSizes[1] || 1}
              maxSize={60 + leftSizes[1] || 1}>
              <div />
            </Allotment.Pane>
            <Allotment.Pane preferredSize="100%" className="z-[4]">
              <div className="allotment-container h-full">{children}</div>
            </Allotment.Pane>
          </Allotment>

          {activeTabType === "user" ? null : (
            <div className="w-full h-full absolute top-0 left-0 ">
              <Allotment onChange={setLeftSizes}>
                <Allotment.Pane
                  className="h-full transition-all duration-100"
                  minSize={datastoresSize[0]}
                  maxSize={datastoresSize[1]}>
                  {isLogged && <DatastoresMenu setSize={setDatastoresSize} />}{" "}
                </Allotment.Pane>

                <Allotment.Pane
                  minSize={datasetMenuMinSize}
                  maxSize={datasetMenuMaxSize}
                  className="datasets-menu-pane h-full transition-all duration-100">
                  {instance &&
                    !!Object.keys(instance).length &&
                    !!datastore_types?.res?.length && (
                      <>
                        {!!instance?.visible && (
                          <div className="overflow-visible h-full pt-2 pb-3 flex items-center">
                            <DatasetsMenu visible={!!instance?.visible} />
                          </div>
                        )}

                        <StyledClose onClick={toggleDatasetsMenu}>
                          {!!instance?.visible && <LeftOutlined />}
                          {!instance?.visible && <RightOutlined />}
                        </StyledClose>
                      </>
                    )}
                </Allotment.Pane>

                <Allotment.Pane className="h-0">
                  <div />
                </Allotment.Pane>
              </Allotment>
            </div>
          )}
        </StyledPanels>
      </div>
    </div>
  );
};

export default LayoutContent;
